import React from "react";
import {Button, Dialog, DialogBody, DialogFooter, DialogHeader,} from "@material-tailwind/react";

export function Modal({children, open, setOpen, size, hideFooter}) {
  const handleOpen = () => setOpen(!open);

  return (
    <>
      <Dialog
        open={open}
        handler={handleOpen}
        size={size}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <DialogHeader className="border-b">
          {children && children.header}
        </DialogHeader>
        <DialogBody>
          {children && children.body}
        </DialogBody>
        {!hideFooter && (
          <DialogFooter className="space-x-2">
            <Button variant="gradient" color="gray" onClick={handleOpen} className="ml-1">
              <span>ذخیره</span>
            </Button>
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
          </DialogFooter>
        )}
      </Dialog>
    </>
  );
}
